import { render, staticRenderFns } from "./approvalAuthorization.vue?vue&type=template&id=f84a74a4&scoped=true"
import script from "./approvalAuthorization.vue?vue&type=script&lang=js"
export * from "./approvalAuthorization.vue?vue&type=script&lang=js"
import style0 from "./approvalAuthorization.vue?vue&type=style&index=0&id=f84a74a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84a74a4",
  null
  
)

export default component.exports